/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Languages } from './languages';

/**
 * Each possible value of `Languages`
 */
export const LANGUAGES: Languages[] = [
  'fr',
  'en'
];